import { render, staticRenderFns } from "./ToolRestrictionModal.vue?vue&type=template&id=49d00f24&scoped=true"
import script from "./ToolRestrictionModal.vue?vue&type=script&lang=js"
export * from "./ToolRestrictionModal.vue?vue&type=script&lang=js"
import style0 from "./ToolRestrictionModal.vue?vue&type=style&index=0&id=49d00f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d00f24",
  null
  
)

export default component.exports